// APS to Unicode Converter
// Based on the original convert_aps_to_unicode function

const array_one_aps = [
    "ef","òeâ","eR","Dee@","X","x","Z","z","eA","ea","Ë","e|","eE","eR","eé",
    "›eâ","kesâ","ke=â","kegâ","Ìkeâ","ÌHeâ","Ìpe","ÌKe","ÌÙe","Ìie","Heâ","heâ","Heä","heä",
    "Ìkeä","ÌK",
    "Ô","~","$e+",
    "Í","Î",
    "Œe","Œ","œe","œ","®","™","¤",

    "ß","$","«","›","¿","Ö","Ø","Ü","ã","ø","õ",
    "#","%","V","„","…","‰","‹","\u201C","\u201D","¢","£","¥","§","©","ª",
    "°","º","»","À","Á","Â","Ã","Ä","Å","Æ","È","É","Ñ","Õ",

    "æ","ñ","ò","ó","ô","ö","ù","ú","û","ÿ",

    "Ì[","Ì{",

    ">","Ÿ","^","Ç","ü","ê",

    "De","F&","F","G","è","S","T",

    "keä","keâ","¡","K","i","I","*",
    "Û","Ú","p","P","_",

    "š","\"","[","{","C",
    "l","L","o","O","v",
    "h","H","y","Y","c",

    "Ù","j","u","}","à","k","J","U","M","ç","ë","<","m","å","n",

    "er","e","¦","¶","ƒ","†","‡","á","ì","í","î",
    "g","Ï","t","Ò","=","ï","s","w","b","B","Š","d","]","Ì","@","Ó","Ê",
    "Q","W",

    "0","1","2","3","4","5","6","7","8","9",

    "्ा","्ो","्ौ","अो","अा","आै","आे","ाो","ाॅ","ॅा","ाे","एे",
    "ंु","ेे","अै","ाे","अे","ंा","अॅ","ाै","ैा","ंृ",
    "ँा","ँू","ेा","ंे","ाें","ॅं","ंॅ"," ः","ंू"
];

const array_two_aps = [
    "µ","क्त","ीं","ऑ","ें&","े&","ैं&","ै&","ीं&","ी&","ं&","&ि","िं","िं","िं",
    "क्र","के","कृ","कु","क़","फ़","ज़","ख़","य़","ग़","फ","फ","फ्","फ्",
    "क़्","ख़्",
    "ॐ","।","ऋ",
    "्रू","्रु",
    "स्त्र","स्त्र्","स्र","स्र्","रु","रू","रू",

    "श्र्","त्र्","ग्र्","व्र्","ज्र्","ह्न","प्र्","ह्र","झ्र्","प्र्","द्र",
    "क्ष्","ज्ञ्","न्न्","ष्ट","ष्ठ","ष्ठ","ङ्घ","ङ्ख","ङ्ग","ह्य्","ह्व","ह्ल","श्च्","द्म्","ट्ठ",
    "ष्ट","ड्ढ","ङ्क","ञ्ज्","ङ्ग","दृ","ञ्च्","व्न्","द्य्","द्भ","ङ्ख","द्व","ढ्ढ","श्व्",
    "द्ध","ड्ड","त्त्","ट्ट","द्ब","द्द","हृ","ठ्ठ","द्ग","ह्म्",

    "ड़","ढ़",
    "्न","्य्","्र","्र","्र","्ल",

    "अ","ई","इ","उ","ऌ","ए","ऊ",

    "क्","क","ख्","ख्","ग्","घ्","ङ",
    "च्","छ","ज्","झ्","ञ्",

    "ट","ठ","ड","ढ","ण्",
    "त्","थ्","द","ध्","न्",
    "प्","प्","ब्","भ्","म्",

    "य्","र","ल्","ल","ळ्","व्","व्","ळ","श्","श्","श्","ष्","स्","ह्","ह",

    "ी","ा","ा","ा","ा","ा","ा","ा","ा","ा","ा",
    "ु","ु","ू","ू","ृ","ॢ","े","ै","ं","ँ","ः","्","़","़","ॅ","ऽ","॰",
    "ैं","ें",

    "०","१","२","३","४","५","६","७","८","९",

    "","े","ै","ओ","आ","औ","ओ","ो","ॉ","ॉ","ो","ऐ",
    "ुं","े","अ‍ै","ो","अ‍े","ां","अ‍ॅ","ौ","ौ","ृं",
    "ाँ","ूँ","ो","ें","ों","ँ","ँ"," :","ूं"
];

export function convert_aps_to_unicode(inputText) {
    if (!inputText || inputText.trim() === '') {
        return '';
    }

    let modified_substring = inputText;
    const array_one_length = array_one_aps.length;

    function Replace_Symbols() {
        // Substitute array_two elements in place of corresponding array_one elements
        if (modified_substring !== "") {
            for (let input_symbol_idx = 0; input_symbol_idx < array_one_length; input_symbol_idx++) {
                let idx = 0;
                while (idx !== -1) {
                    modified_substring = modified_substring.replace(array_one_aps[input_symbol_idx], array_two_aps[input_symbol_idx]);
                    idx = modified_substring.indexOf(array_one_aps[input_symbol_idx]);
                }
            }

            // Handle µ (temporary marker for ि positioning)
            let position_of_i = modified_substring.indexOf("µ");
            while (position_of_i !== -1) {
                const character_next_to_i = modified_substring.charAt(position_of_i + 1);
                const character_to_be_replaced = "µ" + character_next_to_i;
                modified_substring = modified_substring.replace(character_to_be_replaced, character_next_to_i + "ि");
                position_of_i = modified_substring.search(/µ/, position_of_i + 1);
            }

            // Handle wrong ि positioning on half-letters
            let position_of_wrong_ee = modified_substring.indexOf("ि्");
            while (position_of_wrong_ee !== -1) {
                const consonant_next_to_wrong_ee = modified_substring.charAt(position_of_wrong_ee + 2);
                const character_to_be_replaced = "ि्" + consonant_next_to_wrong_ee;
                modified_substring = modified_substring.replace(character_to_be_replaced, "्" + consonant_next_to_wrong_ee + "ि");
                position_of_wrong_ee = modified_substring.search(/ि्/, position_of_wrong_ee + 2);
            }

            // Handle wrong िं positioning on half-letters
            position_of_wrong_ee = modified_substring.indexOf("िं्");
            while (position_of_wrong_ee !== -1) {
                const consonant_next_to_wrong_ee = modified_substring.charAt(position_of_wrong_ee + 3);
                const character_to_be_replaced = "िं्" + consonant_next_to_wrong_ee;
                modified_substring = modified_substring.replace(character_to_be_replaced, "्" + consonant_next_to_wrong_ee + "िं");
                position_of_wrong_ee = modified_substring.search(/िं्/, position_of_wrong_ee + 3);
            }

            // Handle reph (&) positioning
            const set_of_matras = "ा ि ी ु ू ृ े ै ो ौ ं : ँ ॅ";
            let position_of_R = modified_substring.indexOf("&");
            
            while (position_of_R > 0) {
                let probable_position_of_half_r = position_of_R - 1;
                let character_at_probable_position_of_half_r = modified_substring.charAt(probable_position_of_half_r);

                // Find non-matra position left to current & (ie, half-r)
                while (set_of_matras.match(character_at_probable_position_of_half_r) !== null) {
                    probable_position_of_half_r = probable_position_of_half_r - 1;
                    character_at_probable_position_of_half_r = modified_substring.charAt(probable_position_of_half_r);
                }

                const character_to_be_replaced = modified_substring.substr(probable_position_of_half_r, (position_of_R - probable_position_of_half_r));
                const new_replacement_string = "र्" + character_to_be_replaced;
                const full_character_to_be_replaced = character_to_be_replaced + "&";
                modified_substring = modified_substring.replace(full_character_to_be_replaced, new_replacement_string);
                position_of_R = modified_substring.indexOf("&");
            }
        }
    }

    Replace_Symbols();
    return modified_substring;
}
